import Page404 from "./pages/Page404.js";
import Login from "./pages/Login/Login.js";
import Dashboard from "./pages/Dashboard.js";
import Profile from "./pages/Profile.js";
import Clinics from "./pages/Clinics";
import ClinicDetail from "./pages/Clinics/ClinicDetail";
import AdminPatientDetail from "./pages/Clinics/PatientDetail.js";
import Devices from "./pages/Devices";
import UserManagement from "./pages/UserManagement";
import AuditLogs from "./pages/AuditLogs";
import PendingUsers from "./pages/PendingUsers";
import RoleTemplates from "./pages/RoleTemplates";
import SystemFoods from "./pages/SystemVariables/Foods.js";
import SystemDiagnoses from "./pages/SystemVariables/Diagnoses.js";
import SystemDiagnosisCategories from "./pages/SystemVariables/DiagnosisCategories.js";
import SystemLabTests from "./pages/SystemVariables/LabTests.js";
import SystemMedicines from "./pages/SystemVariables/Medicines.js";
import SystemImages from "./pages/SystemVariables/Images.js";
import SystemComplaints from "./pages/SystemVariables/Complaints.js";
import SystemAllergies from "./pages/SystemVariables/Allergies.js";
import SystemTraditionalPractices from "./pages/SystemVariables/TraditionalPractices.js";
import SecretaryPatients from "./pages/Secretary/Patients.js";
import SecretaryPatientDetail from "./pages/Secretary/PatientDetail";
import SecretaryAppointments from "./pages/Secretary/Appointments.js";
import ExaminationSession from "./pages/Examination/ExaminationSession";
import DoctorMedicineTemplates from "./pages/Doctor/Templates/MedicineTemplates.js";
import DoctorDiseaseTemplates from "./pages/Doctor/Templates/DiseaseTemplates.js";
import DoctorDietTemplates from "./pages/Doctor/Templates/DietTemplates.js";
import DoctorImagingTemplates from "./pages/Doctor/Templates/ImagingTemplates.js";
import DoctorLaboratoryTemplates from "./pages/Doctor/Templates/LaboratoryTemplates.js";
import DoctorComplaintTemplates from "./pages/Doctor/Templates/ComplaintTemplates.js";

import ClinicDashboard from "./pages/ClinicDashboard";
import StaffManagement from "./pages/StaffManagement";
import BusinessPerformance from "./pages/BusinessPerformance";
import Financial from "./pages/Financial";
import PrescriptionsClinic from "./pages/PrescriptionsClinic";
import DietsClinic from "./pages/DietsClinic";
import TreatmentsClinic from "./pages/TreatmentsClinic";
import PhoneCallsClinic from "./pages/PhoneCallsClinic";
import PracticeSessionsClinic from "./pages/PracticeSessionsClinic";
import ConsentTemplates from "./pages/ConsentTemplates";
import Messages from "./pages/Messages";
import InvestigationsClinic from "./pages/InvestigationsClinic";
import PanelAppearance from "./pages/PanelManagement/Appearance";
import ClinicManagement from "./pages/ClinicManagement";
import Reports from "./pages/Reports.js";
import ReportDetail from "./pages/ReportDetail.js";

import { Routes, Route, Navigate } from "react-router-dom";
import RequireAuth from "./components/login/RequireAuth.js";

import Layout from "./layout/Layout.js";
import SiteLayout from "./layout/SiteLayout.js";

// ROLES
const ROLES = {
  Admin: "Admin",
  AdminStaff: "AdminStaff",
  ClinicStaff: "ClinicStaff",
  Patient: "Patient",
  PatientRelative: "PatientRelative",
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Login />} />
      </Route>

      {/* Shared routes (Admin + AdminStaff + ClinicStaff) — must come FIRST
          because React Router matches the first path-match and does not fall
          through on role rejection. Keeping /Profil here avoids the case where
          a ClinicStaff user hitting /Profil matches the Admin-only block below
          and silently gets redirected to /login. */}
      <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.AdminStaff, ROLES.ClinicStaff]} />}>
        <Route path="" element={<SiteLayout />}>
          <Route path="Profil" element={<Profile />} />
        </Route>
      </Route>

      {/* Admin and AdminStaff routes */}
      <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.AdminStaff]} />}>
        <Route path="" element={<SiteLayout />}>
          <Route path="Admin-Dashboard" element={<Dashboard />} />
          <Route path="Kullanici-Yonetimi" element={<UserManagement />} />
          <Route path="Kullanici-Yonetimi/Hastalar" element={<UserManagement scope="patients" />} />
          <Route path="Kullanici-Yonetimi/Klinik-Kullanicilari" element={<UserManagement scope="clinic" />} />
          <Route path="Kullanici-Yonetimi/Personeller" element={<UserManagement scope="staff" />} />
          <Route path="Cihazlar" element={<Devices />} />
          <Route path="Klinikler" element={<Clinics />} />
          <Route path="Klinikler/:clinicId" element={<ClinicDetail />} />
          <Route path="Klinikler/:clinicId/Hastalar/:patientId" element={<AdminPatientDetail />} />
          <Route path="Denetim-Gunlugu" element={<AuditLogs />} />
          <Route path="Kullanici-Yonetimi/Personel-Sablonlari" element={<RoleTemplates />} />
          <Route path="Personel-Sablonlari" element={<RoleTemplates />} />
          <Route path="Rol-Sablonlari" element={<RoleTemplates />} />
          <Route path="Bekleyen-Kullanicilar" element={<PendingUsers />} />
          <Route path="Sistem-Degiskenleri/Besinler" element={<SystemFoods />} />
          <Route path="Sistem-Degiskenleri/Tani-Kategorileri" element={<SystemDiagnosisCategories />} />
          <Route path="Sistem-Degiskenleri/Tanilar" element={<SystemDiagnoses />} />
          <Route path="Sistem-Degiskenleri/Tahliller" element={<SystemLabTests />} />
          <Route path="Sistem-Degiskenleri/Ilaclar" element={<SystemMedicines />} />
          <Route path="Sistem-Degiskenleri/Goruntuler" element={<SystemImages />} />
          <Route path="Sistem-Degiskenleri/Sikayetler" element={<SystemComplaints />} />
          <Route path="Sistem-Degiskenleri/Alerjiler" element={<SystemAllergies />} />
          <Route path="Sistem-Degiskenleri/Geleneksel-Uygulamalar" element={<SystemTraditionalPractices />} />
          <Route path="*" element={<Page404 />} />
        </Route>
      </Route>

      {/* ClinicStaff-only routes */}
      <Route element={<RequireAuth allowedRoles={[ROLES.ClinicStaff]} />}>
        <Route path="" element={<SiteLayout />}>
          <Route path="Genel-Bakis" element={<ClinicDashboard />} />
          <Route path="Hastalar" element={<SecretaryPatients />} />
          <Route path="Hastalar/:patientId" element={<SecretaryPatientDetail />} />
          <Route path="Receteler" element={<PrescriptionsClinic />} />
          <Route path="Tetkikler" element={<InvestigationsClinic />} />
          <Route path="Diyetler" element={<DietsClinic />} />
          <Route path="Tedaviler" element={<TreatmentsClinic />} />
          <Route path="Telefon-Gorusmeleri" element={<PhoneCallsClinic />} />
          <Route path="Uygulamalar" element={<PracticeSessionsClinic />} />
          <Route path="Mesajlar" element={<Messages />} />
          <Route path="Randevular" element={<SecretaryAppointments />} />
          {/* Muayene sayfası Randevular'a katıldı; eski bağlantılar için yönlendirme */}
          <Route path="Muayene" element={<Navigate to="/Randevular" replace />} />
          <Route path="Randevular/:appointmentId/Muayene" element={<ExaminationSession />} />
          <Route path="Klinik/Sablonlar/Ilaclar" element={<DoctorMedicineTemplates />} />
          <Route path="Klinik/Sablonlar/Hastaliklar" element={<DoctorDiseaseTemplates />} />
          <Route path="Klinik/Sablonlar/Diyetler" element={<DoctorDietTemplates />} />
          <Route path="Klinik/Sablonlar/Goruntuleme" element={<DoctorImagingTemplates />} />
          <Route path="Klinik/Sablonlar/Laboratuvar" element={<DoctorLaboratoryTemplates />} />
          <Route path="Klinik/Sablonlar/Sikayetler" element={<DoctorComplaintTemplates />} />
          <Route path="Klinik/Sablonlar/Onam-Formlari" element={<ConsentTemplates />} />
          <Route path="Raporlar" element={<Reports />} />
          <Route path="Raporlar/:reportId" element={<ReportDetail />} />
          <Route path="Isletme-Performansi" element={<BusinessPerformance />} />
          <Route path="Personel-Yonetimi" element={<StaffManagement />} />
          <Route path="Finansal" element={<Financial />} />
          <Route path="Klinik-Yonetimi" element={<ClinicManagement />} />
          <Route path="Klinik-Yonetimi/Gorunum" element={<PanelAppearance />} />
          <Route path="Panel-Yonetimi/Gorunum" element={<PanelAppearance />} />
          <Route path="*" element={<Page404 />} />
        </Route>
      </Route>

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default App;
